
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Typewriter extends Vue {
  @Prop({ default: "" }) readonly text!: string;
  @Prop({ default: true }) readonly start!: boolean;
  @Prop({ default: 40 }) readonly speed!: number;

  content = "";
  unwrittenContent = this.text;

  mounted() {
    if (this.start) {
      this.Typewriter();
    }
  }

  Typewriter() {
    if (this.unwrittenContent.length > 0) {
      this.content += this.unwrittenContent.slice(0, 1);
      this.unwrittenContent = this.unwrittenContent.slice(1);
      setTimeout(this.Typewriter, this.speed);
    } else {
      this.$emit("done");
    }
  }

  finish() {
    console.log("clicking")
    this.content = this.text;
    this.unwrittenContent = "";
  }

  @Watch("start")
  started(val: boolean, oldVal: boolean) {
    if (this.start) {
      this.Typewriter();
    }
  }
}
